var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiBrightnessPercent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_7196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0395 8.70994V3.99994H15.3395L11.9995 0.689941L8.70945 3.99994H3.99945V8.70994L0.689453 11.9999L3.99945 15.3399V20.0399H8.70945L11.9995 23.3499L15.3395 20.0399H20.0395V15.3399L23.3495 11.9999L20.0395 8.70994ZM8.82945 7.04994C9.80945 7.04994 10.5995 7.83994 10.5995 8.82994C10.5995 9.29937 10.413 9.74958 10.081 10.0815C9.74909 10.4135 9.29889 10.5999 8.82945 10.5999C7.83945 10.5999 7.04945 9.80994 7.04945 8.82994C7.04945 7.83994 7.83945 7.04994 8.82945 7.04994ZM15.2195 16.9999C14.2395 16.9999 13.4495 16.1999 13.4495 15.2199C13.4495 14.7505 13.6359 14.3003 13.9679 13.9684C14.2998 13.6364 14.75 13.4499 15.2195 13.4499C16.1995 13.4499 16.9995 14.2399 16.9995 15.2199C16.9995 15.692 16.8119 16.1448 16.4781 16.4786C16.1443 16.8124 15.6915 16.9999 15.2195 16.9999ZM8.49945 17.0299L6.99945 15.5299L15.5295 6.99994L17.0295 8.49994L8.49945 17.0299Z",
    fill: "#2A2B79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_7196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBrightnessPercent);
export default __webpack_public_path__ + "static/media/mdi_brightness-percent.7d7498c7e86d7c20e57469b38154b1b8.svg";
export { ForwardRef as ReactComponent };